import { render, staticRenderFns } from "./SettlementsComponent.vue?vue&type=template&id=6643b714&scoped=true"
import script from "./SettlementsComponent.vue?vue&type=script&lang=ts"
export * from "./SettlementsComponent.vue?vue&type=script&lang=ts"
import style0 from "./SettlementsComponent.vue?vue&type=style&index=0&id=6643b714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643b714",
  null
  
)

export default component.exports